import React from 'react';
//import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { HashRouter as Router, Route, Routes } from 'react-router-dom';

import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import ParticipantPage from './pages/ParticipantPage';
import HomePage from './pages/HomePage'; // ضفناها هنا
import LandingPage from "./pages/LandingPage";

import OrganizerPage from "./pages/OrganizerPage";

import AdminPage from "./pages/AdminPage";
import EditEventsPage from "./pages/EditEventsPage";
import SavedEventsPage from './pages/SavedEventsPage'; // استيراد صفحة المحفوظات
import UserRegistrationsPage from './pages/UserRegistrationsPage'; // استيراد صفحة تسجيلات المستخدم
import EditEventForm from './pages/EditEventForm'; // استيراد صفحة تعديل فعالية معينة



function App() {
  return (
    <Router>
      <Routes>


      <Route path="/" element={<LandingPage />} />


      <Route path="/home" element={<HomePage />} />
      <Route path="/participant" element={<ParticipantPage />} />

      <Route path="/saved" element={<SavedEventsPage />} /> {/* إضافة مسار صفحة المحفوظات */}

      <Route path="/organizer" element={<OrganizerPage />} />
      <Route path="/admin" element={<AdminPage />} />
      <Route path="/registrations" element={<UserRegistrationsPage />} /> {/* إضافة مسار صفحة التسجيلات */}
      <Route path="/editForm/:eventId" element={<EditEventForm />} />

        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/editEvent" element={<EditEventsPage />} />

      </Routes>
    </Router>
  );
}

export default App;




